<template>
  <div class="ui-content dashboard leader-sub">
    <div class="user leaderboard-tab">
      <v-tabs
        v-model="tab"
        background-color
        class="elevation-2 cust-tab"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="tType in tabTypes"
          :key="tType.value"
          :href="'#' + tType.value"
        >
          {{ tType.text }}
        </v-tab>
      </v-tabs>
    </div>
    
    <OnlinePastTestList 
      :key="tab" 
      :testType="tab" 
    />
  </div>
</template>

<script>
import OnlinePastTestList from "@/components/student/Tests/OnlinePastTests/OnlinePastTestList.vue";
import { mapMutations } from "vuex";
import constants from "@/utils/constants.js";

export default {
  name: "OnlinePastTest",
  components: {
    OnlinePastTestList,
  },
  data() {
    return {
      tab: null,
      tabTypes: [
        { text: "PYQs", value: constants.TEST_TYPE.PREVIOUS_YEAR },
        { text: "AITS", value: constants.TEST_TYPE.ALL_INDIA_TEST },
        { text: "MYT", value: constants.TEST_TYPE.MYT }
      ],
    };
  },
  mounted() {
    this.initializeTab();
    this.checkSessionData();
    localStorage.setItem("prevPath", this.$route.name);
    
    // Set initial breadcrumb
    this.$nextTick(() => {
      if (this.tab) {
        this.addBreadCrumbChilde([
          {
            text: this.getBreadcrumbText(this.tab),
            disabled: false,
          },
        ]);
      }
    });
  },
  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    
    initializeTab() {
      this.tab = this.tabTypes[0].value;
    },
    
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd && crd.selectedTab) {
        this.tab = crd.selectedTab;
      }
    },
    
    checkSessionData() {
      let rp = this.$route;
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd || !crd.routeName) {
        let defaultDetails = {
          page: 1,
          orderBy: {
            field: "test_name",
            order: "ASC",
          },
          examTypes: [],
          testTypes: [],
        };

        let tabDetail = {};
        this.tabTypes.forEach(type => {
          tabDetail[type.value] = { ...defaultDetails };
        });

        let routeDetails = {
          routeName: rp.name,
          selectedTab: this.tab,
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },
    
    getBreadcrumbText(tabValue) {
      const breadcrumbs = {
        [constants.TEST_TYPE.PREVIOUS_YEAR]: "PYQs",
        [constants.TEST_TYPE.ALL_INDIA_TEST]: "AITS",
        [constants.TEST_TYPE.MYT]: "MYT"
      };
      return breadcrumbs[tabValue] || "";
    },
  },
  watch: {
    tab(val, oldVal) {
      if (oldVal) {
        let routeName = this.$route.name;
        this.setRouteDetails({ routeName, selectedTab: val });
      }
      
      this.addBreadCrumbChilde([
        {
          text: this.getBreadcrumbText(val),
          disabled: false,
        },
      ]);
    },
  },
};
</script>
